<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-20 09:19:57
 * @LastEditTime: 2019-09-20 13:29:59
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id="page_Container" class="networong-page">
        <!-- <img :src="netErrorIcon" alt=""> -->
        <!-- <div class="tips">网络出现异常，加载不出来啦～</div> -->
        <!-- <div class="refresh">刷新</div> -->
        <div class="page">
            <div id="main-container" style='text-align:center;'>
                <div class="tips">网络出现异常，加载不出来啦～</div>
                <van-button plain round type="danger" style='margin-top:30px;' @click="backClick">立即刷新</van-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'networkAnomaly',
    data() {
        return {
            // netWorkUrl: require('../assets/img/home/netwrong.png'),
            imgPreLoadBox: []
        };
    },
    esvReady: function() {
        document.title = '网络异常';
    },
    methods: {
        backClick() {
            this.$router.go(-1);
        }
    }
};
</script>
<style  lang="scss" scoped>
.networong-page {
    width: 100%;
    background-color: #f3f3f3;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    img {
        margin: 138px auto 14px;
        width: 202px;
    }
    .tips {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #999;
        letter-spacing: 0;
    }
    .refresh {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 12px auto;
        font-size: 14px;
        color: #ee2e50;
        cursor: pointer;
        border: 1px solid #ee2e50;
        border-radius: 20px;
    }
}
</style>
